import React from 'react';
import styles from './Toggle.module.css';

class Toggle extends React.Component {
  render() {
    const { on, onChange, label, description, size = 'md', disabled = false } = this.props;

    const pillCls = [
      styles.pill,
      styles[size],
      on ? styles.on : '',
      disabled ? styles.disabled : '',
    ].filter(Boolean).join(' ');

    return (
      <div className={styles.row}>
        {(label || description) && (
          <div className={styles.info}>
            {label      && <div className={styles.label}>{label}</div>}
            {description && <div className={styles.desc}>{description}</div>}
          </div>
        )}
        <div className={pillCls} onClick={disabled ? undefined : onChange} />
      </div>
    );
  }
}

export default Toggle;
